import {AsyncPipe} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {Asset} from '@app/asset';
import {Badge, BadgeService} from '@app/badge/badge.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
    selector: 'frog-badge',
    templateUrl: './badge.component.html',
    styleUrl: './badge.component.scss',
    imports: [AsyncPipe],
})
export class BadgeComponent implements OnInit {
    @Input() asset: Asset;

    public badge$: Observable<Badge>;

    constructor(private badgeService: BadgeService) {}

    ngOnInit() {
        this.badge$ = this.badgeService.badges.pipe(map((badges) => this.getBadge(badges)));
    }

    private getBadge(badges: Badge[]): Badge {
        let badge = null;
        for (const tag of this.asset.tags) {
            badge = this.badgeService.getByTag(tag.id);
            if (badge !== null) {
                break;
            }
        }

        return badge;
    }
}
